import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Get or create cart session ID
export const getCartSessionId = () => {
  let sessionId = localStorage.getItem('cart_session_id');
  if (!sessionId) {
    sessionId = 'cart_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('cart_session_id', sessionId);
  }
  return sessionId;
};

// Books API
export const getBooks = async (params = {}) => {
  const response = await api.get('/books', { params });
  return response.data;
};

export const getBook = async (id) => {
  const response = await api.get(`/books/${id}`);
  return response.data;
};

export const getFeaturedBooks = async () => {
  const response = await api.get('/books', { params: { featured: true } });
  return response.data;
};

// Cart API
export const getCart = async () => {
  const sessionId = getCartSessionId();
  const response = await api.get(`/cart/${sessionId}`);
  return response.data;
};

export const addToCart = async (bookId, quantity = 1, format = 'digital') => {
  const sessionId = getCartSessionId();
  const response = await api.post(`/cart/${sessionId}/add`, {
    book_id: bookId,
    quantity,
    format,
  });
  return response.data;
};

export const updateCartItem = async (bookId, quantity, format = 'digital') => {
  const sessionId = getCartSessionId();
  const response = await api.post(`/cart/${sessionId}/update`, {
    book_id: bookId,
    quantity,
    format,
  });
  return response.data;
};

export const removeFromCart = async (bookId, format = 'digital') => {
  const sessionId = getCartSessionId();
  const response = await api.delete(`/cart/${sessionId}/item/${bookId}`, {
    params: { format },
  });
  return response.data;
};

export const clearCart = async () => {
  const sessionId = getCartSessionId();
  const response = await api.delete(`/cart/${sessionId}`);
  return response.data;
};

// Checkout API
export const createCheckout = async (customerEmail = null, shippingInfo = null) => {
  const sessionId = getCartSessionId();
  const originUrl = window.location.origin;
  const response = await api.post('/checkout', {
    cart_session_id: sessionId,
    origin_url: originUrl,
    customer_email: customerEmail,
    shipping_info: shippingInfo,
  });
  return response.data;
};

export const getCheckoutStatus = async (sessionId) => {
  const response = await api.get(`/checkout/status/${sessionId}`);
  return response.data;
};

// PayPal API
export const createPayPalOrder = async (bookId, formatName) => {
  const response = await api.post('/paypal/create-order', {
    book_id: bookId,
    format_name: formatName,
  });
  return response.data;
};

export const capturePayPalOrder = async (orderId) => {
  const response = await api.post(`/paypal/capture-order/${orderId}`);
  return response.data;
};

// Newsletter API
export const subscribeNewsletter = async (email) => {
  const response = await api.post(`/newsletter/subscribe?email=${encodeURIComponent(email)}`);
  return response.data;
};

// Notify (Coming Soon) API
export const notifyMe = async (email, bookId = null, bookTitle = null) => {
  const response = await api.post('/notify', {
    email,
    book_id: bookId,
    book_title: bookTitle,
  });
  return response.data;
};

// Blog API
export const getBlogPosts = async () => {
  const response = await api.get('/blog');
  return response.data;
};

export const getBlogPost = async (slug) => {
  const response = await api.get(`/blog/${slug}`);
  return response.data;
};

// Contact API
export const submitContact = async (data) => {
  const response = await api.post('/contact', data);
  return response.data;
};

// Seed data
export const seedData = async () => {
  const response = await api.post('/seed');
  return response.data;
};

export default api;
